import auth from '@/auth'

const HasRole = {
  install (Vue) {
    Vue.directive('has-role', {
      bind (el, binding) {
        let value = binding.value
        if (!auth.hasRoles(value)) {
          el.style.display = 'none'
        }
      }
    })
  }
}

if (window.Vue) {
  window.Vue.use(HasRole)
}

export default HasRole



// WEBPACK FOOTER //
// ./src/directives/hasRole.js